<template>

  <div>
  <div class="hit-btn-group" data-hit-toggleswitch>

    <div class="hit-btn" v-bind:class="get_class(0)" v-on:click="click" v-html="get_label(0)"></div>
    <div class="hit-btn" v-bind:class="get_class(1)" v-on:click="click" v-html="get_label(1)"></div>

  </div>

</div>
</template>

<script>

export default{

  name: 'toggle_switch',
  props: {'data': [Array, Object], 'value': [String, Boolean, Number], 'callback': Function},
  data: function () { return {active: false} },
  methods: {

    get_label: function (id) {
      var type = typeof this.$props['data']

      if (type.toLowerCase() === 'array') { return this.$props['data'][id] }

      if (type.toLowerCase() === 'object') {
        return Object.keys(this.$props['data'])[id]
      }
    },

    get_class: function (id) {
      if (!this.active) { this.active = this.$props['value'] }

      var type = typeof this.$props['data']

      if (type.toLowerCase() === 'array') { this.check = this.$props['data'][id] }

      if (type.toLowerCase() === 'object') { this.check = Object.values(this.$props['data'])[id] }

      return {'hit-btn-default': this.active != this.check, 'hit-btn-info': this.active == this.check}
    },

    click: function () {
      var type = typeof this.$props['data']

      if (type.toLowerCase() === 'array') { this.check = this.$props['data'] }

      if (type.toLowerCase() === 'object') { this.check = Object.values(this.$props['data']) }

      if (this.active == this.check[0]) { this.active = this.check[1] } else { this.active = this.check[0] }

      this.$props.callback(this.active)
    }
  }
}

</script>
